import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import { useDispatch, useSelector } from "react-redux";
import { getWithDrawRequest } from "../../store/withdraw/withdraw.action";
import Table from "../../extra/Table";
import Pagination from "../../extra/Pagination";
import Button from "../../extra/Button";
import Searching from "../../extra/Searching";
import { ReactComponent as TrueIcon } from "../../../assets/icons/TrueArrow.svg";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trashIcon.svg";

import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { type } from "@testing-library/user-event/dist/type";
import Reason from "./Reason";
import { getDefaultCurrency } from "../../store/currency/currency.action";
import defaultImage from "../../../assets/images/noimage.png";
import { IconCheck, IconInfoCircle, IconX } from "@tabler/icons-react";
import LazyImage from "../../../common/ImageFallback";
import UniqueIdCopy from "../../extra/UniqueIdCopy";

const WithDrawRequest = (props) => {
  const { withdraw, total } = useSelector((state) => state.withdraw);

  const { dialogueType } = useSelector((state) => state.dialogue);
  const { defaultCurrency } = useSelector((state) => state.currency);

  const dispatch = useDispatch();

  const { startDate, endDate } = props;

  const [page, setPage] = useState(1);

  const [size, setSize] = useState(20);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(getWithDrawRequest(1, page, size, startDate, endDate, search || ""));
    dispatch(getDefaultCurrency());
  }, [dispatch, page, size, startDate, endDate, search]);

  useEffect(() => {
    setData(withdraw);
  }, [withdraw]);



  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleServerSearch = (value) => {
    setPage(1);
    setSearch(value || "");
  };



  const ManageUserData = [
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },

    {
      Header: "USERNAME",
      body: "userName",
      Cell: ({ row }) => (
        <div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
          {/* <img
        src={row?.userId?.image}
        width="50px"
        height="50px"
        alt="user"
        className="rounded-circle me-2"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultImage; // fallback image
        }}
      /> */}
          <LazyImage imageSrc={row?.userId?.image} width="50px" height="50px" />
          <div className="ms-3 ">
            {/* Nick Name */}
            <div className="fw-semibold text-start text-capitalize">
              {row?.userId?.fullName || "-"}
            </div>

            {/* Full Name */}
            <div className="text-muted small text-start text-capitalize">
              {row?.userId?.nickName || "-"}
            </div>
            <div className="text-muted small text-start text-capitalize">
              <UniqueIdCopy value={row?.userId?.uniqueId} placeholder="-" />
            </div>
          </div>
        </div>
      ),
    },

    {
      Header: `REQUEST AMOUNT(${defaultCurrency?.symbol ? defaultCurrency?.symbol : ""
        })`,
      body: "requestAmount",
      Cell: ({ row }) => (
        <span className="text-lowercase cursorPointer">
          {row?.requestAmount}{defaultCurrency?.symbol}
        </span>
      ),
    },
    {
      Header: "TRANSACTION ID",
      body: "uniqueId",
      Cell: ({ row }) => (
        <span className="text-nowrap">{row?.uniqueId || "—"}</span>
      ),
    },
    {
      Header: "CHANNEL Name",
      body: "channelName",
      Cell: ({ row }) => (
        <span className="text-capitalize  text-nowrap">{row?.channelName}</span>
      ),
    },
    {
      Header: "CHANNEL ID",
      body: "channelId",
      Cell: ({ row }) => (
        <span className="text-capitalize  text-nowrap">{row?.channelId}</span>
      ),
    },
    {
      Header: "REQUEST DATE",
      body: "requestDate",
      Cell: ({ row }) => (
        <span className="text-nowrap">{row?.requestDate || "—"}</span>
      ),
    },

    {
      Header: "PAYMENT",
      body: "infoPayment",
      Cell: ({ row }) => (
        <span
          className="cursorPointer d-inline-flex align-items-center"
          onClick={() => handlePaymentInfo(row)}
          title="View payment details"
        >
          <IconInfoCircle size={20} className="text-secondary" />
        </span>
      ),
    },

    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) => (
        <div className="action-button">
          {/* <Button
            btnName={`Pay`}
            newClass={`fw-bolder bg-success text-white w-70`}
            onClick={() => handleEdit(row, "pay")}
          />
          <Button
            btnName={`Decline`}
            newClass={`fw-bolder bg-danger text-white w-70`}
            onClick={() => handleDecline(row, "decline")}
          /> */}

          <button className="btn btn-sm" onClick={() => handleEdit(row, "pay")}>
            <IconCheck className="text-secondary" />
          </button>
          <button className="btn btn-sm" onClick={() => handleDecline(row, "decline")}>
            <IconX className="text-secondary" />
          </button>
        </div>
      ),
    },
  ];

  const handleEdit = (row, type) => {

    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handleDecline = (row, type) => {

    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });
    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const handlePaymentInfo = (row) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: { type: "info", data: row },
    });
    sessionStorage.setItem(
      "dialogueData",
      JSON.stringify({ dialogue: true, type: "info", dialogueData: row })
    );
  };

  return (
    <div>
      <div className="user-table real-user mb-3">
        {dialogueType == "decline" && <Reason />}

        <div className="user-table-top">


          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="w-100">
              <h5
                style={{
                  fontWeight: "500",
                  fontSize: "20px",
                  marginTop: "5px",
                  marginBottom: "4px",
                }}
              >
                Withdrawal Request
              </h5>
            </div>
            <Searching
              placeholder={"Search..."}
              type={"server"}
              serverSearching={handleServerSearch}
              setSearchData={setSearch}
              className={"d-flex justify-content-end w-100"}
              label={"Search for Transaction ID, Username"}
              hideActionDropdown={true}
              actionShow={false}
            />
          </div>
        </div>
        <Table
          data={data}
          mapData={ManageUserData}
          serverPerPage={size}
          serverPage={page}
          type={"server"}
        />
        <Pagination
          type={"server"}
          activePage={page}
          rowsPerPage={size}
          userTotal={total}
          setPage={setPage}
          handleRowsPerPage={handleRowsPerPage}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default WithDrawRequest;
